import { PLAN_FEATURES, type PlanFeature } from '@goaltree/backend/convex/lib/usage'
import { Dialog, DialogContent } from '@goaltree/ui/components/dialog'
import { useTranslation } from 'react-i18next'

import { LoginForm } from '@/components/login-form'
import { UpgradeDialog } from '@/components/upgrade-dialog'
import { useUsageLimitStore } from '@/lib/usage-limit'

export function UsageLimitPrompt() {
  const { t } = useTranslation()
  const hit = useUsageLimitStore((s) => s.hit)
  const set = useUsageLimitStore((s) => s.set)
  const isPlan = !!hit && PLAN_FEATURES.includes(hit.feature as PlanFeature)
  if (hit?.plan === 'anonymous')
    return (
      <Dialog open onOpenChange={(open) => !open && set(null)}>
        <DialogContent>
          <LoginForm
            onComplete={() => set(null)}
            surface="modal"
            returnTo={window.location.pathname + window.location.search}
            title={t('usageLimit.anonTitle')}
            subtitle={t('usageLimit.anonDesc')}
          />
        </DialogContent>
      </Dialog>
    )
  if (hit?.feature === 'habits')
    return <UpgradeDialog open onOpenChange={(open) => !open && set(null)} reason="habit-limit" />
  return (
    <UpgradeDialog
      open={!!hit}
      onOpenChange={(open) => !open && set(null)}
      reason="usage-limit"
      feature={hit?.feature}
      title={
        isPlan
          ? t('usageLimit.planTitle')
          : hit
            ? t('usageLimit.trialTitle', { feature: t(`usageLimit.features.${hit.feature}`) })
            : undefined
      }
      description={t(isPlan ? 'usageLimit.planDesc' : 'usageLimit.trialDesc')}
    />
  )
}
